const CHIP = "flex items-center justify-center h-9 px-3 rounded-md border border-white/10 font-mono text-[11px] font-bold tracking-wide";

export const PaymentLogos = () => (
  <div className="flex flex-wrap gap-2.5" data-testid="payment-logos">
    <span className={`${CHIP} bg-white`} style={{ color: "#1a1f71" }}>VISA</span>
    <span className={`${CHIP} bg-black/40`} style={{ color: "#eb001b" }}>Mastercard</span>
    <span className={`${CHIP} bg-black/40`} style={{ color: "#ffb3c7" }}>Klarna</span>
    <span className={`${CHIP} bg-black/40 text-white`}> Pay</span>
    <span className={`${CHIP} bg-black/40 text-white`}>G Pay</span>
    <span className={`${CHIP} bg-white`} style={{ color: "#10298e" }}>SEPA</span>
  </div>
);
